import { NavigationGuardNext, Route } from "vue-router";

import vuex from "@/lib/vuex";
import { replicable } from "@/lib/axios";
import storeVuex from "@/lib/vuex";
import router from "@/lib/router";
import message from "@/lib/message";
import i18n from "@/lib/i18n";
import AuditsResourceApi from "@/lib/apis/replicable/operations/AuditsResourceApi";

import store, { getInitialContext, localStorageKey, prefixLocalStorageAudit, prefixLocalStorageYear } from "./store";
import { Context, AuditContext } from "./typings";

export async function getAuditContextStored(): Promise<Context> {
	const contextStored = localStorage.getItem(localStorageKey);

	if (contextStored && contextStored.startsWith(prefixLocalStorageAudit)) {
		const id = parseInt(contextStored.substring(prefixLocalStorageAudit.length), 10);

		if (id) {
			try {
				return new AuditContext(await AuditsResourceApi.get(id, {}, "none"));
			} catch (e) {
				localStorage.removeItem(localStorageKey);
			}
		} else {
			localStorage.removeItem(localStorageKey);
		}
	} else if (contextStored && contextStored.startsWith(prefixLocalStorageYear)) {
		return {
			year: parseInt(contextStored.substring(prefixLocalStorageYear.length))
		};
	}

	return getInitialContext();
}

export default {
	install() {
		if (replicable.defaults.transformRequest instanceof Array) {
			replicable.defaults.transformRequest.push((data: any, headers: any) => {
				const audit = storeVuex.getters["context/audit"];
				const year = storeVuex.getters["context/year"];

				if (audit) {
					headers["Audit-Context-Id"] = audit.id;
				}

				if (year) {
					headers["Audit-Context-Year"] = year;
				}

				return data;
			});
		}

		i18n.mergeLocaleMessage("fr", {
			"context.is.missing": "Un contexte est nécessaire pour accèder à cette page."
		});

		router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
			if (!storeVuex.state.context.selected) {
				message.warning(i18n.t("context.is.missing") as string);
				next("/audits");
				return;
			}

			next();
		});

		vuex.registerModule("context", store);
	}
};
export * from "./typings";
export { default as ContextSelector } from "./vues/ContextSelector.vue";
export { default as AuditConditionalNotifier } from "./components/AuditConditionalNotifier.vue";
export { default as MultipleAuditNotifier } from "./components/MultipleAuditNotifier.vue";
